(function () {
  function cleanCanonical() {
    var link = document.querySelector('link[rel="canonical"]');
    if (!link || !link.href) return;

    try {
      var url = new URL(link.href, window.location.origin);

      // UX-only
      url.searchParams.delete('view');

      // Native collection sort / faceting (theme no longer renders these UIs)
      url.searchParams.delete('sort_by');

      var keys = Array.from(url.searchParams.keys());
      keys.forEach(function (key) {
        if (key.indexOf('filter.') === 0) {
          url.searchParams.delete(key);
        }
      });

      // Keep ?page= and any other params (e.g. markets, third-party) unless removed above
      link.href = url.toString();
    } catch (e) {
      // Fail silently
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanCanonical);
  } else {
    cleanCanonical();
  }

  setTimeout(cleanCanonical, 50);
  setTimeout(cleanCanonical, 250);
  setTimeout(cleanCanonical, 1000);
})();